import request from '@/util/request';
//搜索
export const getDeviceMaintennanceStandardList = (params, options) =>
request.get('/api/deviceupkeepstandard/page', Object.assign({}, options, { params }));

//添加
export const addDeviceMaintenanceStandard = (params) =>
request.post('/api/deviceupkeepstandard/saveUpkeep',params);

//查看
export const getDeviceMaintennanceStandardDetail = (params, options) =>
request.get('/api/deviceupkeepstandard/detail', Object.assign({}, options, { params }));

//编辑
export const UpdateDeviceMaintennanceStandard = (params) =>
request.post('/api/deviceupkeepstandard/submit',params);

//删除
export const deleteDeviceMaintennanceStandard = (id) =>
request.post('/api/deviceupkeepstandard/delete?ids='+id);
//删除
export const stopDeviceMaintennanceStandard = (params) =>
request.post('/api/deviceupkeepstandard/startToStop',params);


//关联设备 启用
export const lookStandardUpkeepDevice = (params, options) =>
request.get('/api/deviceupkeepstandard/lookStandardUpkeepDevice', Object.assign({}, options, { params }));

//关联设备 停用
export const lookStandardStopUpkeepDevice = (params, options) =>
request.get('/api/deviceupkeepstandard/lookStandardStopUpkeepDevice', Object.assign({}, options, { params }));

//维保选择关联设备
export const standardUpkeepDevice = (params, options) =>
request.get('/api/deviceupkeepstandard/standardUpkeepDevice', Object.assign({}, options, { params }));
//新增关联设备
export const relationUpkeepDevice = (params) =>
request.post('/api/deviceupkeepstandard/relationUpkeepDevice',params);

//关联设备 移除
export const removeUpkeepDevice = (params) =>
request.post('/api/deviceupkeepstandard/removeUpkeepDevice',params);